import {
  GetIngestionDocumentFragment,
  InternalGetIngestionDocumentFragment,
} from '@client/graphql/__generated__/types';

/**
 * Creates field labels, optionally scoped to one contract document.
 */
export function createFieldKeyToLabelMapping(
  document?: Pick<
    GetIngestionDocumentFragment | InternalGetIngestionDocumentFragment,
    'contractDocuments'
  > | null,
  contractDocumentUuid?: string
): Record<string, string> {
  const mapping: Record<string, string> = {};

  if (!document?.contractDocuments) {
    return mapping;
  }

  document.contractDocuments.forEach((contractDoc) => {
    if (contractDocumentUuid && contractDoc.id !== contractDocumentUuid) {
      return;
    }
    const documentVersion = contractDoc.documentVersion;
    if (documentVersion?.documentVersionFields) {
      documentVersion.documentVersionFields.forEach((docVersionField) => {
        const field = docVersionField.field;
        if (field?.mappingKey) {
          const label = field.label || field.mappingKey;
          mapping[field.mappingKey] = label;
        }
      });
    }
  });

  return mapping;
}
